module.exports = __webpack_public_path__ + "static/media/National Rural Economic Developers Association Logo.0b84e6e8.jpg";